<template>
  <div class="commission-settings py-5 px-4">
    <v-container class="custom-container">
      <v-row dense class="no-gutters">
        <v-col cols="12">
          <v-card class="deposit-form create-account-form" :color="$vuetify.theme.dark ? 'transparent' : 'transparent'">
            <v-row dense>
              <v-col cols="12" sm="6" md="6" lg="3" :sm="$canRoute('commission-tree') !== 1 ? 12 : 6"  :md="$canRoute('commission-tree') !== 1 ? 12 : 6" :lg="$canRoute('commission-tree') !== 1 ? 6 : 3">
                <v-text-field class="search-field" v-model="search" prepend-icon="mdi-magnify" label="Search..."
                  single-line solo hide-details>
                </v-text-field>
              </v-col>
              <v-col cols="12" sm="6" md="6" lg="3">
                <v-select solo :items="formattedAccountTypesWithAll" item-text="display" item-value="id"
                  v-model="selectedAccountType" append-icon="mdi-chevron-down" label="Account Type"
                  class="custom-select">
                </v-select>
              </v-col>
              <v-col cols="12" sm="6" md="6" lg="3">
                <v-select solo :items="formattedCurrencyGroupsWithAll" item-text="title" item-value="id"
                  v-model="selectedCurrencyGroup" append-icon="mdi-chevron-down" label="Currency Group"
                  class="custom-select">
                </v-select>
              </v-col>
              <v-col cols="12" sm="6" md="6" lg="3">
                <AddNewCommissionModal></AddNewCommissionModal>
              </v-col>
            </v-row>
            <v-row dense class="pb-5">
              <v-col cols="12">
                <commission-tree-data-table :access="$canRoute('commission-tree')" :search="search" :levelCounts="levelCounts"
                  :commissions="allcommissiontrees?.commissionSetup">
                </commission-tree-data-table>
              </v-col>
            </v-row>
          </v-card>
        </v-col>
      </v-row>
    </v-container>
  </div>
</template>

<script>
import AddNewCommissionModal from "@/components/Partners/AddNewCommissionModal.vue";
import CommissionTreeDataTable from '@/components/Partners/CommissionTreeDataTable.vue';
import { mapState, mapActions } from "vuex";
import { COMMISSIONTREE__ACTIONS } from "@/store/action-types";

export default {
  name: 'CommissionSettings',

  components: {
    AddNewCommissionModal,
    CommissionTreeDataTable
  },

  data() {
    return {
      search: "",
      selectedCurrencyGroup: 'all',  // Default to 'all'
      selectedAccountType: 'all'     // Default to 'all'
    };
  },

  computed: {
    ...mapState("commissiontree", [
      "levelCounts",
      "tierCounts",
      "accountTypes",
      "currencyGroups",
      "allcommissiontrees"
    ]),

    formattedAccountTypesWithAll() {
      const allOption = [{
        id: 'all',
        display: 'All Account Types'
      }];
      return [...allOption, ...(this.formattedAccountTypes || [])];
    },

    formattedAccountTypes() {
      return this.accountTypes
        ? this.accountTypes.map(type => ({
          id: type?.id,
          display: `${type?.account_type_display?.toUpperCase()} (${type?.LiveDemo} ${type?.Mt4Mt5})`,
        }))
        : [];
    },

    formatedAccountTypeName() {
      return this.accountTypes
        ? this.accountTypes?.find(account => account?.id === this.selectedAccountType)?.account_type_display
        : null;
    },

    formatedCurrencyGroupName() {
      return this.currencyGroups
        ? this.currencyGroups?.find(group => group?.id === this.selectedCurrencyGroup)?.title
        : null;
    },

    formattedCurrencyGroupsWithAll() {
      const allOption = [{
        id: 'all',
        title: 'All Currency Groups'
      }];
      return [...allOption, ...(this.formattedCurrencyGroups || [])];
    },

    formattedCurrencyGroups() {
      return this.currencyGroups
        ? this.currencyGroups.map(type => ({
          id: type?.id,
          title: type?.title,
        }))
        : [];
    },
  },

  watch: {
    selectedAccountType(newValue) {
      this[COMMISSIONTREE__ACTIONS.ALLCOMMISSIONTREES]({
        account_type: newValue === 'all' ? null : newValue,
      });
    },
    selectedCurrencyGroup(newValue) {
      this[COMMISSIONTREE__ACTIONS.ALLCOMMISSIONTREES]({
        currency_group: newValue === 'all' ? null : newValue
      });
    }
  },

  methods: {
    ...mapActions("commissiontree", [
      COMMISSIONTREE__ACTIONS.GETCOMMISSIONSETTINGS,
      COMMISSIONTREE__ACTIONS.ALLCOMMISSIONTREES
    ]),
  },

  async mounted() {
    await this[COMMISSIONTREE__ACTIONS.GETCOMMISSIONSETTINGS]();
    await this[COMMISSIONTREE__ACTIONS.ALLCOMMISSIONTREES]();
  },
};
</script>